import React, { useMemo } from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as Icons from '../Admin/AdminLogos';
import { WhatsAppLogo } from '../Sidebar/SidebarLogos';

const DefaultIcon = Icons.HomeLogo;

// Function to determine manager type - can be updated when backend provides this info
const getManagerType = (user) => {
    // For now, assume all managers are basic. This can be updated to check user.plan or user.subscription
    // return user.plan === 'upgraded' ? 'upgraded' : 'basic';
    return 'basic'; // Placeholder - change to 'upgraded' for testing upgraded features
};

const ManagerSidebarItems = ({ sidebarShow }) => {
    const { pathname } = useLocation();
    const { user } = useSelector((state) => state.auth);
    const managerType = getManagerType(user);

    const baseMenuItems = [
        { path: '/manager/dashboard', icon: 'HomeLogo', label: 'Home' },
        { path: '/manager/dashboard/user-management', icon: 'UserManagement', label: 'User Management' },
        { path: '/manager/dashboard/transfer-credit', icon: 'CreditLogo', label: 'Credit Management' },
        { path: '/manager/dashboard/transfer-credit-history', icon: 'SMSReport', label: 'Credit Transfer History' },
        { path: '/manager/dashboard/sms-analytics', icon: 'SmsTraffic', label: 'SMS Analytics' },
        { path: '/manager/dashboard/sms-campaign', icon: 'SMSCampaignLogo', label: 'SMS Campaign Report' },
        { path: '/manager/dashboard/sms-transaction-report', icon: 'SMSReport', label: 'SMS Transaction Report' },
    ];

    const whatsAppMenuItems = [
        // Single WhatsApp item for all managers
        { path: '/manager/dashboard/whatsapp', icon: 'WhatsAppLogo', label: 'WhatsApp', managerTypes: ['basic', 'upgraded'] },
    ];

    const menuItems = useMemo(() => {
        const filteredWhatsAppItems = whatsAppMenuItems.filter(item =>
            item.managerTypes.includes(managerType)
        );

        // Insert WhatsApp items after SMS items
        return [
            ...baseMenuItems,
            ...filteredWhatsAppItems
        ];
    }, [managerType]);

    const renderNavItem = useMemo(() => (item) => {
        let Icon;
        if (item.icon === 'WhatsAppLogo') {
            Icon = WhatsAppLogo;
        } else {
            Icon = Icons[item.icon] || DefaultIcon;
        }

        const isActive = !item.external && pathname === item.path;
        const linkProps = item.external
            ? { as: 'a', href: item.path, target: '_blank', rel: 'noopener noreferrer' }
            : { as: Link, to: item.path };

        const content = (
            <>
                <span className="nav-icon">
                    <Icon />
                </span>
                <span className="toggle-name">{item.label}</span>
            </>
        );

        const navLink = (
            <Nav.Link {...linkProps} active={isActive}>
                {content}
            </Nav.Link>
        );

        return (
            <Nav.Item as="li" key={item.path}>
                {sidebarShow ? (
                    navLink
                ) : (
                    <OverlayTrigger
                        placement="right"
                        overlay={<Tooltip id={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}>{item.label}</Tooltip>}
                    >
                        {navLink}
                    </OverlayTrigger>
                )}
            </Nav.Item>
        );
    }, [pathname, sidebarShow]);

    return (
        <Nav as="ul" className="responsive-scroll">
            {menuItems.map(renderNavItem)}
        </Nav>
    );
};

export default ManagerSidebarItems;
